import type { FC } from "react";

import { languageSelector } from "@/src/contexts";
import { Home } from "@Routes/HomepageLinks";

import ImageBanner, { type IImageBanner } from "../common/ImageBanner";
import { TransitionButton } from "../common/Transition";
import { InvalidDiscountImageResources } from "./InvalidDiscountImage.Resources";
import { InvalidDiscountImageResourcesEn } from "./InvalidDiscountImage.Resources.En";

import * as css from "./InvalidDiscountImage.module.css";

const InvalidDiscountImage: FC<IImageBanner> = (props) => {
    const resources = languageSelector(InvalidDiscountImageResources, InvalidDiscountImageResourcesEn);

    return (
        <div className={css.invalidDiscountImageComponent}>
            <ImageBanner {...props} />
            <div className={css.invalidDiscount}>
                <h1 className={css.title}>{resources.invalidDiscountText}</h1>
                <TransitionButton text={resources.goActiveOffers} navigateUrl={Home} />
            </div>
        </div>
    );
};

export default InvalidDiscountImage;
